<template>
  <div
    class="custom-group-tours-faq-card"
    :class="{
      active: isExpand,
      'bd-b-1 bd-hairline': !isExpand,
    }"
  >
    <div
      class="pa-16 sd-5 br-12 mb-8"
      :class="{
        'sd-none': !isExpand,
      }"
    >
      <button type="button" class="faq-trigger" :aria-expanded="isExpand" @click="expand">
        <h3
          class="fs-20 fw-700 lh-28 ls-1 faq-question"
          v-html="question"
        ></h3>
        <svg class="faq-chevron" :class="{ active: isExpand }" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M3.5 5.25L7 8.75L10.5 5.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <Transition name="fade">
        <p v-show="isExpand" class="fw-500 fs-16 lh-22 mb-0 answer">
          {{ answer }}
        </p>
      </Transition>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'


// eslint-disable-next-line no-undef
const props = defineProps({
  question: {
    type: String,
    default: 'What do you need from me to start designing a Private Group Tour?',
  },
  answer: {
    type: String,
    default: `To start designing a Private Group Tour, we need as much detail as possible through the enquiry form. Please provide us with the estimated group size, preferred departure month, budget guidelines, any special requirements, and, if available, sample itineraries or links to preferred tours. This information allows us to create a tailored itinerary that aligns with your group's needs, preferences, and required experience. The more detail you can provide in the initial enquiry, the better, and quicker, we can start designing the best trip for you!`,
  },
  shouldOpen: {
    type: Boolean,
    default: false,
  }
})

const isExpand = ref(props.shouldOpen)
const expand = () => {
  isExpand.value = !isExpand.value
}

watch(()=> props.shouldOpen, (v)=>isExpand.value = v)
// onMounted(() => {
//   isExpand.value = props.shouldOpen
// })
</script>

<style lang="scss" scoped>
// v2 Accordion — real button trigger (was <div @click>, no keyboard access/aria-expanded),
// green label (was gray-dark/inherited black), single chevron that rotates 180° in 200ms
// (was two swapped up/down icon images with no transition).
.faq-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin-bottom: 10px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  color: $link;
  @include focus-ring;
}
.faq-question {
  color: inherit;
}
.faq-chevron {
  flex-shrink: 0;
  color: $link;
  transition: transform $dur-base $ease-out;
  &.active {
    transform: rotate(180deg);
  }
}
@media (prefers-reduced-motion: reduce) {
  .faq-chevron {
    transition: none;
  }
}
</style>
